// extracted by mini-css-extract-plugin
module.exports = {"main":"SchoolBadge_main__ZZ30J"};